<template>
  <div class="tblFilterHesabCode">
    <div class="table-respon" style="max-height: 140px; overflow-y: auto">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead class="bg-primary-light sticky-top">
          <td>ردیف</td>
          <td>کد</td>
          <td>عنوان ({{ TbPersonDataFilter.length }} مورد)</td>
        </thead>
        <tbody>
          <tr
            v-for="row in getListDataPaging"
            :key="row.NCode"
            v-on:click="selectRowVal(row.NPerID, row.NPerName, row.NPerLastName, row.NPerType)"
            v-on:dblclick="dblClickRow(row.NPerID, row.NPerName, row.NPerLastName, row.NPerType)"
            v-bind:id="'trafhesab-' + row.NPerID"
            :class="{ selRow: selectRow.NPerID == row.NPerID }"
            style="cursor: pointer;"
          >
            <td>{{ row.RowID }}</td>
            <td>{{ row.NPerID }}</td>
            <td style="
              max-width: 200px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;"
              :title="row.NPerName + ' ' + row.NPerLastName"
            >{{ row.NPerName + ' ' + row.NPerLastName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row h12 text-secondary mt-2 d-flex justify-content-center align-items-center">
      <div class="col-9 text-right">
        راهنما : فلش <i class="fas fa-long-arrow-alt-up px-1"></i> و <i class="fas fa-long-arrow-alt-down px-1"></i> حرکت بین سطرها ، F4/Enter انتخاب
      </div>
      <div class="col-3">
        <PaginationSmallTarafHesab
          v-bind:Name="'PaginationSmallTarafHesab'" 
          v-bind:CountRow="intCountRow"
          v-bind:DataRepository="TbPersonDataFilter" 
          v-on:ChangePage="ChangePage"
        ></PaginationSmallTarafHesab>
      </div>
    </div>

  </div>
</template>

<script>
import { BusEvent } from "../../../../../main.js";
import PaginationSmallTarafHesab from "../../PublicComponents/PaginationSmall.vue"

export default {
  name: "FilterTarafHesab",
  components:{
    PaginationSmallTarafHesab
  },
  data() {
    return {
      TbPersonData: [],
      TbPersonDataFilter: [],

      selectRow: {
        NPerID: 0,
        NPerName: "",
        NPerLastName: "",
        NPerType: 0,
      },

      // مربوط به صفحه بندی
      intPageNumber: 1,  // شماره صفحه در حال انتخاب
      intCountRow: 100,   // تعداد سطرها در هر صفحه
      intCountPage: 1,   // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده در صفحه - ممکن است صفحه 200 سطر کامل نباشد

    };
  },
  props: ['TarafCode','NAccType','RandomNumberChild'],
  watch: {
    TarafCode: function (value) {
      this.filterTbPersonData(value);
    },
    RandomNumberChild: function (value) {
      console.log('TarafHesab NAccType: ', this.NAccType);
      this.filterTbPersonData(this.TarafCode);
    },
  },
  computed: {
    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      if (this.TbPersonDataFilter.length > 0) {
        // شماره شروع رکورد
        let startRowIndex = this.intPageNumber == 1 ? 1 : (parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) + 1);
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.TbPersonDataFilter.filter(function (item) {
          return (item.RowID >= startRowIndex && item.RowID < (parseInt(startRowIndex) + parseInt(intCountRowLocal)))
        });
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  methods: {
    // رویداد تغییر صفحه از کامپاننت صفحه بندی
    ChangePage(value) {
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    async getTbPersonData() {
      this.TbPersonData = await this.$store.getters.getTbPersonData(this.NAccType);
      // درج شماره ردیف برای لیست
      this.TbPersonData = await this.$store.dispatch('setRowIDForList', this.TbPersonData);
      this.TbPersonDataFilter = this.TbPersonData;
    },

    async filterTbPersonData(value) {
      if(value != 0 && value != ''){
        this.TbPersonDataFilter = this.TbPersonData.filter(function (t) {
          // return t.NPerID.startsWith(value) || t.NPerName.includes(value) || t.NPerLastName.includes(value);
          return t.NPerID.toString().startsWith(value);
        });
        // درج شماره ردیف برای لیست
        this.TbPersonDataFilter = await this.$store.dispatch('setRowIDForList', this.TbPersonDataFilter);
      } else {
        this.TbPersonDataFilter = this.TbPersonData;
      }
    },

    dblClickRow(NPerID, NPerName, NPerLastName, NPerType) {
      this.selectRowVal(NPerID, NPerName, NPerLastName, NPerType);
      this.SelectTarafHesab();
    },

    selectRowVal(NPerID, NPerName, NPerLastName, NPerType) {
      this.selectRow.NPerID = NPerID;
      this.selectRow.NPerName = NPerName;
      this.selectRow.NPerLastName = NPerLastName;
      this.selectRow.NPerType = NPerType;
    },

    SelectTarafHesab() {
      if (this.selectRow.NPerID == 0) {
        this.$store.dispatch(
          "notify",
          "طرف حسابی در حالت انتخاب نیست !\nلطفا ابتدا یکی از طرف حساب ها را در حالت انتخاب قرار دهید ."
        );
      } else {
        this.$emit("HideFilterTarafHesab", {
          NPerID: this.selectRow.NPerID,
          NPerName: this.selectRow.NPerName,
          NPerLastName: this.selectRow.NPerLastName,
          NPerType: this.selectRow.NPerType,
        });

      }
    },

    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      if (this.TbPersonDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbPersonDataFilter.findIndex(
            (itme) => itme.NPerID == this.selectRow.NPerID
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRowVal(
                  this.TbPersonDataFilter[index - 1].NPerID,
                  this.TbPersonDataFilter[index - 1].NPerName,
                  this.TbPersonDataFilter[index - 1].NPerLastName,
                  this.TbPersonDataFilter[index - 1].NPerType
                );
                $(
                  "#trafhesab-" + this.TbPersonDataFilter[index - 1].NPerID
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            } else {
              if (index + 1 < this.TbPersonDataFilter.length) {
                this.selectRowVal(
                  this.TbPersonDataFilter[index + 1].NPerID,
                  this.TbPersonDataFilter[index + 1].NPerName,
                  this.TbPersonDataFilter[index + 1].NPerLastName,
                  this.TbPersonDataFilter[index + 1].NPerType
                );
                $(
                  "#trafhesab-" + this.TbPersonDataFilter[index + 1].NPerID
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            }
          } else {
            this.selectRowVal(
              this.TbPersonDataFilter[0].NPerID,
              this.TbPersonDataFilter[0].NPerName,
              this.TbPersonDataFilter[0].NPerLastName,
              this.TbPersonDataFilter[0].NPerType
            );
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4"  || keyvalue.key === "Enter") {
          this.SelectTarafHesab();
        }
      }
    },
  },
  created() {
    this.getTbPersonData();
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
};
</script>

<style scoped>
.tblFilterHesabCode {
  position: absolute;
  background-color: #fee3e8;
  width: 400px;
  min-height: 80px;
  /* max-height: 170px; */
  margin-top: 35px;
  z-index: 99999;
  /* top: 52px; */
  padding: 5px;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 5px;
}

.tblFilterHesabCode table {
  background-color: white;
}

.selRow {
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/Components/FilterTarafHesab.vue